// extracted by mini-css-extract-plugin
export default {"overview":"Dashboard_overview__dDR0r","container":"Dashboard_container__mUEKr","dashboard_tabs":"Dashboard_dashboard_tabs__byiVy"};